
import { Component, Mixins } from "vue-property-decorator";
import { LengthAlertBehavior } from "../../../../../../documaker/domain/format/objects";
import { ILengthAlertBehaviorPropertyEditable, instanceOfILengthAlertBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class LengthAlertBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ILengthAlertBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ILengthAlertBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isLengthAlertBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfILengthAlertBehaviorPropertyEditable(s) && s.lengthAlertBehavior().isEditable(), false);
  }

  get lengthAlertBehavior(): LengthAlertBehavior {
    return this.readPropertyOrDefault(s => LengthAlertBehavior.from(s.lengthAlertBehavior().getValue()), new LengthAlertBehavior(false, null, false));
  }

  set lengthAlertBehavior(value: LengthAlertBehavior) {
    this.writePropertyWhenValid(s => s.lengthAlertBehavior().setValue(LengthAlertBehavior.to(value)));
  }
}
